module.exports = __webpack_public_path__ + "media/images/logo-c8fa9c0e3948e80798f8db8b19f41c4a.png";